import axios from "axios"
import {setQuery} from "../utils/utils";

interface IncomingDataForApi {
    vehicleId: string,
    start_date: Date,
    end_date: Date
}

function getDailyStatisticsByVehicleIdApi(data: IncomingDataForApi ){
    const { vehicleId, start_date, end_date } = data;

    return axios({
        method: "GET",
        url: `/api/v1/daily-stats/vehicles/${vehicleId}${setQuery({start_date}, {end_date})}`,
    })
}

async function getDailyStatisticsByVehicleIdExportCsvApi(vehicleId: string, start_date: string, end_date: string){
    function query() {
        if (!start_date && !end_date) return "";
        let query = "?";
        if (start_date) query = query + "start_date=" + start_date + "&";
        if (end_date) query = query + "end_date=" + end_date + "&";
        return query.slice(0, query.length - 1)
    }
    return axios({
        method: "GET",
        url: `/api/v1/daily-stats-sum/db-vehicles/${vehicleId}/export-csv${query()}`,
        responseType: 'blob', // important
    }).then((response) => {
        const file = response.headers['content-disposition'].split(" ", 2)[1].split("=", 2)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute( 'download', file[1]); //or any other extension
        document.body.appendChild(link);
        link.click();
    });
}

async function getDailyStatisticsByVehicleIdExportExcelApi(vehicleId: string, start_date: string, end_date: string){
    function query() {
        if (!start_date && !end_date) return "";
        let query = "?";
        if (start_date) query = query + "start_date=" + start_date + "&";
        if (end_date) query = query + "end_date=" + end_date + "&";
        return query.slice(0, query.length - 1)
    }
    return axios({
        method: "GET",
        url: `/api/v1/daily-stats-sum/db-vehicles/${vehicleId}/export-excel${query()}`,
        responseType: 'blob', // important
    }).then((response) => {
        const file = response.headers['content-disposition'].split(" ", 2)[1].split("=", 2)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute( 'download', file[1]); //or any other extension
        document.body.appendChild(link);
        link.click();
    });
}

async function getDailyStatisticsByVehicleIdExportPdfApi(vehicles: string[], start_date: string, end_date: string, title: string = "doc"){
    function query() {
        if (!start_date && !end_date) return "";
        let query = "?";
        if (vehicles.length > 0 ) {
            vehicles.forEach((item: string) => {
                query = query + "vehicles[]=" + item + "&"
            })
        }
        if (start_date) query = query + "start_date=" + start_date + "&";
        if (end_date) query = query + "end_date=" + end_date + "&";
        return query.slice(0, query.length - 1)
    }
    return axios({
        method: "GET",
        url: `/api/v1/daily-stats-sum/db-vehicles/export-pdf${query()}`,
        responseType: 'blob', // important
    }).then((response) => {
        // const file = response.headers['content-disposition'].split(" ", 2)[1].split("=", 2)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute( 'download',`${title}.pdf`); //or any other extension
        document.body.appendChild(link);
        link.click();
    });
}

async function getDistanceReportByVehicleIdExports(
    vehicles: string[],
    start_date: string,
    end_date: string,
    type: string = "csv",
    title: string = "doc"
){
    function query() {
        if (!vehicles  && !start_date && !end_date) return "";
        let query = "?";
        if (type) query = query + "type=" + type + "&";
        if (vehicles.length > 0 ) {
            vehicles.forEach((item: string) => {
                query = query + "vehicles[]=" + item + "&"
            })
        }
        if (start_date) query = query + "start_date=" + start_date + "&";
        if (end_date) query = query + "end_date=" + end_date + "&";
        return query.slice(0, query.length - 1)
    }

    return axios({
        method: "GET",
        url: `/api/v1/daily-stats/vehicles/export${query()}`,
        responseType: 'blob', // important
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${title}.${type}`); //or any other extension
        document.body.appendChild(link);
        link.click();
    });
}

async function getDistanceReportByDriversIdExports(
    drivers: string[],
    start_date: string,
    end_date: string,
    type: string = "csv",
    title: string = "doc"
){
    function query() {
        if (!drivers  && !start_date && !end_date) return "";
        let query = "?";
        if (type) query = query + "type=" + type + "&";
        if (drivers.length > 0 ) {
            drivers.forEach((item: string) => {
                query = query + "drivers[]=" + item + "&"
            })
        }
        if (start_date) query = query + "start_date=" + start_date + "&";
        if (end_date) query = query + "end_date=" + end_date + "&";
        return query.slice(0, query.length - 1)
    }

    return axios({
        method: "GET",
        url: `/api/v1/driver-stats/export${query()}`,
        responseType: 'blob', // important
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${title}.${type}`); //or any other extension
        document.body.appendChild(link);
        link.click();
    });
}

async function getFuelReportByVehicleApi(data: {vehicleId: string, start_date: any, end_date: any}){
    const { start_date, end_date, vehicleId } = data;
    return axios({
        method:"GET",
        url: `/api/v1/fuel-vehicle-stats/${vehicleId}${setQuery({start_date}, {end_date})}`
    })
}
async function getFuelReportByDriverApi(data: {driverId: string, start_date: any, end_date: any}){
    const { start_date, end_date, driverId } = data;
    return axios({
        method:"GET",
        url: `api/v1/fuel-driver-stats/${driverId}${setQuery({start_date}, {end_date})}`
    })
}

export {
    getDailyStatisticsByVehicleIdApi,
    getDailyStatisticsByVehicleIdExportCsvApi,
    getDailyStatisticsByVehicleIdExportExcelApi,
    getDailyStatisticsByVehicleIdExportPdfApi,
    getDistanceReportByVehicleIdExports,
    getDistanceReportByDriversIdExports,
    getFuelReportByVehicleApi,
    getFuelReportByDriverApi,
}